import {
  Box,
  Typography,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
  IconButton,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../../assets/images/logo.svg";
import { string } from "../../../constants/string";
import { useState } from "react";
import claimIcon from "../../../assets/images/claimIcon.svg";
import { useClaimTypeStore } from "../../../store/useClaimTypeStore";
import { useNavigate } from "react-router-dom";

export default function Header(props: any) {
  const { onNavClick } = props;
  const [claimsOpen, setClaimsOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const setClaimType = useClaimTypeStore((state) => state.setClaimType);
  const claimType = useClaimTypeStore((state) => state.claimType);

  const navItems = [
    { label: string.welcome.home, value: "home" },
    { label: string.welcome.claimStatus, value: "claimStatus" },
    { label: string.welcome.aboutUs, value: "aboutUs" },
    // { label: "Workspace", value: "workspace" },
    ...(claimType ? [] : [{ label: string.welcome.claims, value: "claims" }]),
  ];

  const handleNavClick = (item: any) => {
    if (item.value === "claims") {
      setClaimsOpen((prev) => !prev);
    } else if (item.value === "workspace") {
      setClaimsOpen(false);
      setClaimType("");
      setDrawerOpen(false);
      navigate("/workspace");
    } else {
      onNavClick(item.value);
      setClaimsOpen(false);
      setClaimType("");
      setDrawerOpen(false);
    }
  };

  const handleSubItemClick = (value: "DEATH" | "TEN_PERCENT") => {
    setClaimType(value);
    onNavClick(value);
    setClaimsOpen(false);
    setDrawerOpen(false);
  };

  return (
    <Box
      component="header"
      sx={{
        height: "140px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2, md: 18 },
        backgroundColor: "background.default",
        position: "relative",
      }}
    >
      {/* Logo */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={logo}
          alt="Logo"
          style={{
            height: 80,
            width: 206,
            objectFit: "contain",
            cursor: "pointer",
          }}
          onClick={() => (window.location.href = "/")}
        />
      </Box>

      {/* Desktop Navigation */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          gap: 4,
          alignItems: "center",
          position: "relative",
        }}
      >
        {navItems.map((item, i) => (
          <Box key={i} sx={{ position: "relative" }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "text.primary",
                cursor: "pointer",
              }}
              onClick={() => handleNavClick(item)}
            >
              {item.label}
            </Typography>

            {item.value === "claims" && (
              <Collapse
                in={claimsOpen}
                timeout="auto"
                unmountOnExit
                sx={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  mt: 1,
                  zIndex: 10,
                  backgroundColor: "background.paper",
                  boxShadow: "none",
                  borderRadius: 1,
                  minWidth: 200,
                }}
              >
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 2, borderBottom: "1px solid #DFDDDD" }}
                    onClick={() => handleSubItemClick("TEN_PERCENT")}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <img src={claimIcon} alt="claimIcon" />
                    </ListItemIcon>
                    <ListItemText
                      primary={string.sidebar.percentClaim}
                      slotProps={{
                        primary: {
                          sx: {
                            color: "text.primary",
                            fontWeight: 500,
                            fontSize: 16,
                          },
                        },
                      }}
                    />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 2 }}
                    onClick={() => handleSubItemClick("DEATH")}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <img src={claimIcon} alt="claimIcon" />
                    </ListItemIcon>
                    <ListItemText
                      primary={string.sidebar.deathClaim}
                      slotProps={{
                        primary: {
                          sx: {
                            color: "text.primary",
                            fontWeight: 500,
                            fontSize: 16,
                          },
                        },
                      }}
                    />
                  </ListItemButton>
                </List>
              </Collapse>
            )}
          </Box>
        ))}
      </Box>

      {/* Hamburger for Mobile */}
      <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center" }}>
        <IconButton onClick={() => setDrawerOpen(true)}>
          <MenuIcon fontSize="large" />
        </IconButton>
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 250, p: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontWeight={600}>
              Menu
            </Typography>
            <IconButton onClick={() => setDrawerOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ my: 2 }} />

          {navItems.map((item, i) => (
            <Box key={i}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "text.primary",
                  py: 1,
                  cursor: "pointer",
                }}
                onClick={() => handleNavClick(item)}
              >
                {item.label}
              </Typography>

              {item.value === "claims" && claimsOpen && (
                <Box ml={2}>
                  <Typography
                    sx={{ py: 1, cursor: "pointer" }}
                    onClick={() => handleSubItemClick("TEN_PERCENT")}
                  >
                    {string.sidebar.percentClaim}
                  </Typography>
                  <Typography
                    sx={{ py: 1, cursor: "pointer" }}
                    onClick={() => handleSubItemClick("DEATH")}
                  >
                    {string.sidebar.deathClaim}
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Drawer>
    </Box>
  );
}
